import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

  datadogRum.init({
    applicationId: environment.datadog.applicationId, 
    site: environment.datadog.site,
    service: environment.datadog.service,
    env: environment.datadog.env,
    clientToken: environment.datadog.clientToken,
    version: '1.0.0',
    sampleRate: 100,
    replaySampleRate: 100,
    trackInteractions: true,   
    defaultPrivacyLevel: 'mask-user-input',
  })